import axios from 'axios';
import API_HOST from '../api';
import aesReduxConstants from '../constants';
import sopApi from '../apis/sopApi';

const sopActions = function() {
  const actions = {};

  const api = sopApi;
  const constants = aesReduxConstants;

  actions.getClientList = function(clientId, successCallback) {
    return function(dispatch) {
      api.getClientList(clientId)
        .then((response) => {
          const pages = response.data;
          dispatch(actions.getClientListSuccess(pages));
          if (typeof successCallback === 'function') {
            successCallback();
          }
        }, (error) => {
          dispatch(actions.genericModalError('Error Getting SOP Pages', error));
        });
    };
  };

  actions.genericModalError = function(title, error) {
    return {
      type: constants.SOP_GENERIC_ERROR,
      error: {
        title,
        error,
      },
    };
  };

  actions.getClientListSuccess = function(pages) {
    return {
      type: constants.GET_CLIENT_SOP_LIST_SUCCESS,
      pages,
    };
  };

  actions.getPage = function(clientId, pageId, version, format, successCallback) {
    return function(dispatch) {
      dispatch({ type: constants.GET_CLIENT_SOP_PAGE });

      api.getPage(clientId, pageId, version, format)
        .then((response) => {
          const page = response.data;

          dispatch(actions.getPageSuccess(page));
          if (successCallback !== undefined) {
            successCallback(page);
          }
        }, () => {
          dispatch(actions.getPageNotFound());
        });
    };
  };

  actions.getPageSuccess = function(page) {
    return {
      type: constants.GET_CLIENT_SOP_PAGE_SUCCESS,
      page,
    };
  };

  actions.getPageNotFound = function() {
    return {
      type: constants.GET_CLIENT_SOP_PAGE_NOT_FOUND,
    };
  };

  actions.getPageVersions = function(clientId, pageId, successCallback) {
    return function(dispatch) {
      dispatch({ type: constants.GET_CLIENT_SOP_PAGE_VERSIONS });

      api.getPageVersions(clientId, pageId)
        .then((response) => {
          const versions = response.data;
          dispatch(actions.getPageVersionsSuccess(versions));
          if (successCallback !== undefined) successCallback();
        }, (error) => {
          dispatch(actions.genericModalError('Error Getting SOP Versions', error));
        });
    };
  };

  actions.getPageVersionsSuccess = function(versions) {
    return {
      type: constants.GET_CLIENT_SOP_PAGE_VERSIONS_SUCCESS,
      versions,
    };
  };

  actions.updatePage = function(clientId, pageId, page, comment, successCallback) {
    return function(dispatch) {
      dispatch({ type: constants.UPDATE_CLIENT_SOP_PAGE });

      api.updatePage(clientId, pageId, page, comment)
        .then((page) => {
          dispatch(actions.updatePageSuccess(page));
          if (successCallback !== undefined) successCallback(page);
        }, (error) => {
          dispatch(actions.genericModalError('Error Updating SOP Page', error));
        });
    };
  };

  actions.updatePageSuccess = function(page) {
    return {
      type: constants.UPDATE_CLIENT_SOP_PAGE_SUCCESS,
      page,
    };
  };

  actions.createPage = function(clientId, page, comment, successCallback) {
    return function(dispatch) {
      dispatch({ type: constants.CREATE_CLIENT_SOP_PAGE });

      api.createPage(clientId, page, comment)
        .then((page) => {
          dispatch(actions.createPageSuccess(page));
          if (successCallback !== undefined) successCallback();
        }, (error) => {
          dispatch(actions.genericModalError('Error Creating SOP Page', error));
        });
    };
  };

  actions.createPageSuccess = function(page) {
    return {
      type: constants.CREATE_CLIENT_SOP_PAGE_SUCCESS,
      page,
    };
  };

  actions.archivePage = function(clientId, pageId, archive) {
    return function(dispatch) {
      dispatch({ type: constants.ARCHIVE_CLIENT_SOP_PAGE });

      if (archive) {
        api.unArchivePage(clientId, pageId)
          .then(() => {
            dispatch(actions.archivePageSuccess(false));
          });
      } else {
        api.archivePage(clientId, pageId)
          .then(() => {
            dispatch(actions.archivePageSuccess(true));
          });
      }
    };
  };

  actions.archivePageSuccess = function(archived) {
    return {
      type: constants.ARCHIVE_CLIENT_SOP_PAGE_SUCCESS,
      archived,
    };
  };

  actions.updateListOrder = function(clientId, ids, successCallback) {
    return function(dispatch) {
      dispatch({ type: constants.UPDATE_CLIENT_SOP_LIST_ORDER });

      api.updateListOrder(clientId, ids)
        .then((success) => {
          dispatch(actions.updateListOrderSuccess());
          successCallback(success);
        }, (error) => {
          dispatch(actions.genericModalError('Error Updating List Order', error));
        });
    };
  };

  actions.updateListOrderSuccess = function() {
    return {
      type: constants.UPDATE_CLIENT_SOP_LIST_ORDER_SUCCESS,
    };
  };

  actions.getPagePreview = function(content) {
    return function(dispatch) {
      api.getPagePreview(content)
        .then((response) => {
          const preview = response.data;
          dispatch(actions.getPagePreviewSuccess(preview));
        }, (error) => {
          dispatch(actions.genericModalError('Error Getting Page Preview', error));
        });
    };
  };

  actions.getPagePreviewSuccess = function(preview) {
    return {
      type: constants.GET_SOP_PAGE_PREVIEW,
      preview,
    };
  };

  actions.updateCurrentPageContent = function(content) {
    return {
      type: constants.UPDATE_CURRENT_SOP_PAGE_CONTENT,
      content,
    };
  };

  actions.updateCurrentPageTitle = function(title) {
    return {
      type: constants.UPDATE_CURRENT_SOP_PAGE_TITLE,
      title,
    };
  };

  return actions;
};

export default sopActions();
